import Navbar from "components/Navbar";
import HeroSection from "components/sections/home/HeroSection";
import Footer from "components/sections/home/HomeFooter";
import PageHeader from "components/PageHeader";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import Map from "components/Map";
import ExploreDivision from "components/sections/home/ExploreDivision";
import Compliance from "components/sections/home/Compliance";
import Industries from "components/sections/home/Industries";
// import Banner from "components/Banner";

const Home = () => {
  const { t } = useTranslation("home");

  const isMobile = useMediaQuery({ maxWidth: "768px" });
  return (
    <main>
      <PageHeader title="Home | Smartcomply" />
      <Navbar />
      <HeroSection />
      <ExploreDivision />
      <Compliance />
      <Industries />
      <Map />
      <Footer />
    </main>
  );
};

export default Home;
